module.exports = __webpack_public_path__ + "themify.9c8e96ecc7fa01e6ebcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/icons/themify-icons/fonts/themify.svg?-fvbane
// module id = ./src/assets/styles/icons/themify-icons/fonts/themify.svg?-fvbane
// module chunks = styles